const ownerKey = user => `jaggis:pos:pending:${user.admin_id}:${user.staff_id}:${user.branch_id}:${user.counter_id}`;
export function writePending(user, record, storage = sessionStorage) {
  storage.setItem(ownerKey(user), JSON.stringify({version:1,record}));
}
export function readPending(user, storage = sessionStorage) {
  const raw=storage.getItem(ownerKey(user));
  if (!raw) return null;
  const saved=JSON.parse(raw);
  if (saved.version!==1 || !saved.record?.payload?.request_id || !Array.isArray(saved.record?.payload?.items)) throw new Error('Pending payment data needs manual reconciliation');
  return saved.record;
}
export function clearPending(user, storage = sessionStorage) { storage.removeItem(ownerKey(user)); }
export function writePendingCash(user,payload,storage=sessionStorage){storage.setItem(`${ownerKey(user)}:cash`,JSON.stringify(payload));}
export function readPendingCash(user,storage=sessionStorage){const raw=storage.getItem(`${ownerKey(user)}:cash`);return raw?JSON.parse(raw):null;}
export function clearPendingCash(user,storage=sessionStorage){storage.removeItem(`${ownerKey(user)}:cash`);}
